import * as z from "zod";

export const speechToText = {
  name: "speechToText" as const,

  // Input schema: we receive the audio as base64 encoded data
  input: z.object({
    // Audio data encoded as base64
    audioData: z.string().min(1, "Audio data is required"),
    // Optional language code (Whisper auto-detects if not provided)
    languageCode: z.string().optional(),
  }),

  // Output schema: return the transcribed text
  output: z.object({
    // The transcribed text
    text: z.string(),
  }),
};
